import { Component, OnDestroy, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-location-card',
    templateUrl: './location-card.component.html',
    styleUrls: ['./location-card.component.css'],
    standalone: false
})
export class LocationCardComponent implements OnInit, OnDestroy {
    @Input() location;

    constructor() {}

    ngOnInit() {}
    ngOnDestroy() {}
}